/* ============================================================
   TENUTA GRIECI · tg-haptics.js   —   17/10/2026
   Un colpetto di vibrazione quando si tocca una voce della tab bar
   in basso (.tg-tabbar, costruita da tg-upgrades.js). Solo lì, non
   su ogni link della pagina.

   · Android (Chrome, Samsung Internet): navigator.vibrate, l'API
     ufficiale, con un impulso di 12 ms.
   · iPhone: Safari non ha navigator.vibrate. Si usa il metodo di
     ios-haptics 3 (github.com/tijnjh/ios-haptics, licenza MIT):
     sopra ogni voce c'è un interruttore <input type="checkbox" switch>
     trasparente; il dito tocca davvero l'interruttore e Safari dà il
     suo riscontro tattile nativo. Il vecchio trucco (clic simulato
     dal codice) Apple l'ha chiuso in iOS 26.5; questo, secondo
     l'autore della libreria, funziona ancora. Da riprovare su un
     iPhone vero quando esce una nuova versione di iOS.
   · Con l'interruttore sopra, il tocco arriva a lui e non al link:
     la pagina la apre questo file. Tastiera e VoiceOver attivano il
     link direttamente e non passano di qui.
   · Dove nessuna delle due strade c'è (computer, iPhone con iOS
     precedente al 17.4) la barra funziona come prima, senza vibrazione.

   addSwitch() deriva da ios-haptics, che chiede di riportare qui
   la sua licenza:

   MIT License  Copyright (c) 2025 tijn

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice (including the
   next paragraph) shall be included in all copies or substantial
   portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   ============================================================ */
(function () {
  'use strict';
  var IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var VIBRATE = !IOS && typeof navigator.vibrate === 'function' &&
                matchMedia('(pointer:coarse)').matches;
  if (!IOS && !VIBRATE) return;

  /* tg-upgrades.js costruisce la barra su DOMContentLoaded e nel layout
     viene prima di questo file: il suo listener parte prima del nostro. */
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('.tg-tabbar');
    if (!bar) return;

    if (VIBRATE) {
      bar.addEventListener('click', function (e) {
        if (e.target.closest('.tg-tabbar__btn')) { try { navigator.vibrate(12); } catch (err) {} }
      });
      return;
    }

    var btns = bar.querySelectorAll('.tg-tabbar__btn');
    for (var i = 0; i < btns.length; i++) addSwitch(btns[i]);

    /* In bolla sulla barra: il listener di tg-upgrades.js ha già spostato
       la luce sulla voce toccata. */
    bar.addEventListener('click', function (e) {
      var sw = e.target;
      if (!sw.hasAttribute || !sw.hasAttribute('data-tg-haptic') || sw.__tgMoved) return;
      var a = sw.parentElement, url = a && a.href;
      if (!url) return;
      /* Chrome non segue un link se il clic è su un controllo al suo
         interno, Safari invece può seguirlo dopo il clic. Si toglie href
         per un istante: la pagina si apre una volta sola, da qui. */
      a.removeAttribute('href');
      setTimeout(function () { a.setAttribute('href', url); }, 0);
      location.assign(url);
    });
  });

  function addSwitch(a) {
    if (a.querySelector('[data-tg-haptic]')) return;
    var sw = document.createElement('input');
    sw.type = 'checkbox';
    sw.setAttribute('switch', '');
    sw.setAttribute('data-tg-haptic', '');
    sw.setAttribute('aria-hidden', 'true');
    sw.tabIndex = -1;
    sw.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;margin:0;opacity:0;' +
      'clip-path:inset(0 round 999px);touch-action:pan-x pan-y;-webkit-tap-highlight-color:transparent';

    /* Un gesto che parte sulla barra e scorre la pagina non è un tocco. */
    var y0 = 0;
    sw.addEventListener('pointerdown', function (e) { y0 = e.clientY; sw.__tgMoved = false; }, { passive: true });
    sw.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientY - y0) > 10) { sw.__tgMoved = true; sw.checked = false; }
    }, { passive: true });
    sw.addEventListener('pointercancel', function () { sw.__tgMoved = true; sw.checked = false; }, { passive: true });

    a.appendChild(sw);
  }
})();
